import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    linkedToMultipleSequences: string;
    linkedToSequence: string;
    linkedToSequenceWithName: (sequenceName: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            linkedToMultipleSequences: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceIcon.linkedToMultipleSequences?c=19a0uel5uvucz", defaultMessage: "Linked to multiple sequences" }));
                },
                enumerable: true,
                configurable: true
            },
            linkedToSequence: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SequenceIcon.linkedToSequence?c=1zxgtlxq494re", defaultMessage: "Linked to sequence" }));
                },
                enumerable: true,
                configurable: true
            },
            linkedToSequenceWithName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (sequenceName: string) => __intl__.intl().formatMessage({ id: "SequenceIcon.linkedToSequenceWithName?c=1k2zeyxxskbtd", defaultMessage: "Linked to {sequenceName}" }, { sequenceName: sequenceName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
